module.exports = __webpack_public_path__ + "static/img/home_sofa.97256e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/home_sofa.png
// module id = fFc6
// module chunks = 3